import { useState } from "react";
import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { Box } from "@chakra-ui/react";
import useGetEspeciesDoc from "core/features/contas_bancarias/hooks/useGetEspeciesDoc";

export interface SelectEspecieDocumentoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any, item: any) => void;
  isInvalid?: boolean;
  bancoId: string;
}

function SelectEspecieDocumento({
  value,
  onChange,
  isInvalid,
  bancoId,
  ...rest
}: SelectEspecieDocumentoProps) {
  const [search, setSearch] = useState<string | undefined>();
  const { isFetching, data } = useGetEspeciesDoc(bancoId);

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      loading={isFetching}
      size="large"
      placeholder="Selecione a espécie de documento"
      value={value || undefined}
      onChange={onChange}
      searchValue={search}
      onSearch={setSearch}
      showSearch
      allowClear
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
      notFoundContent={<Box>Nenhuma espécie de documento encontrada</Box>}
    />
  );
}

export default SelectEspecieDocumento;
